import EmployeeOnlyModalContainer from "#/components/employee-only-containers/EmployeeOnlyModalContainer"
import { CarrotDeductibleInformational } from "#/components/views/reimbursements/educationmodal/CarrotDeductibleInformational"
import { ExternalDeductibleInformational } from "#/components/views/reimbursements/educationmodal/ExternalDeductibleInformational"
import { ExternalDeductibleAndOopmInformational } from "#/components/views/reimbursements/educationmodal/ExternalDeductibleAndOopmInformational"
import { YourCostShareInformational } from "#/components/views/reimbursements/educationmodal/YourCostShareInformational"
import { reimbursementCategoryNameMessageKeys } from "#/components/views/reimbursements/reimbursementCategoryNameMessageKeys"
import { Subsidy } from "#/lib/carrot-api/types/Subsidy"
import { getIsMemberOfCarrotCardCompany } from "#/redux/derivedSelectors"
import { useToggle } from "#/utils/Hooks"
import {
  Box,
  BoxProps,
  CloseIcon,
  Dialog,
  IconButton,
  InfoIcon,
  Typography,
  useTheme
} from "@carrotfertility/carotene-core"
import React, { FC } from "react"
import { useIntl } from "react-intl"
import { useSelector } from "react-redux"

type PlanInfoBadgeProps = {
  subsidy: Subsidy
  children: React.ReactNode
  modalType: "cmd" | "emd" | "emdAndOopm" | "costShare"
} & Pick<BoxProps, "sx">

export const PlanInfoBadge: FC<PlanInfoBadgeProps> = ({ subsidy, sx, children, modalType }) => {
  const [showModal, toggleModal] = useToggle()
  const theme = useTheme()
  const intl = useIntl()
  const hasCarrotCard = useSelector(getIsMemberOfCarrotCardCompany)

  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" sx={sx}>
      <Typography variant="body1" color={theme.palette.text.secondary}>
        {children}
      </Typography>
      <IconButton
        onClick={(event) => {
          event.stopPropagation()
          toggleModal()
        }}
        size="small"
        sx={() => ({ pointerEvents: "auto" })}
      >
        <InfoIcon />
        {showModal && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            onClick={(event) => {
              event.stopPropagation()
            }}
          >
            <EmployeeOnlyModalContainer onClose={toggleModal}>
              <Dialog
                aria-labelledby={
                  modalType === "costShare"
                    ? "cost-share-modal-header"
                    : modalType === "emdAndOopm"
                    ? "deductible-oopm-modal-header"
                    : "deductible-modal-header"
                }
                maxWidth="md"
                onClose={toggleModal}
                open={showModal}
              >
                {modalType !== "emd" && modalType !== "emdAndOopm" && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <IconButton aria-label={intl.formatMessage({ defaultMessage: "close" })} onClick={toggleModal}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                )}
                {modalType === "cmd" && <CarrotDeductibleInformational hasCostShare={subsidy.hasCostShare} />}
                {modalType === "emd" && (
                  <ExternalDeductibleInformational hasCostShare={subsidy.hasCostShare} onClose={toggleModal} />
                )}
                {modalType === "emdAndOopm" && <ExternalDeductibleAndOopmInformational onClose={toggleModal} />}
                {modalType === "costShare" && (
                  <YourCostShareInformational
                    reimbursementRules={subsidy.reimbursementRules}
                    isDefaultCategory={
                      subsidy.reimbursementCategoryNameMessageKey === reimbursementCategoryNameMessageKeys.DEFAULT
                    }
                    hasCarrotCard={hasCarrotCard}
                  />
                )}
              </Dialog>
            </EmployeeOnlyModalContainer>
          </div>
        )}
      </IconButton>
    </Box>
  )
}
